module.exports = __webpack_public_path__ + "img/cidue-logo.ac5df868.png";